import { render, staticRenderFns } from "./pageSearch.vue?vue&type=template&id=39c054c6&scoped=true"
import script from "./pageSearch.vue?vue&type=script&lang=js"
export * from "./pageSearch.vue?vue&type=script&lang=js"
import style0 from "./pageSearch.vue?vue&type=style&index=0&id=39c054c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c054c6",
  null
  
)

export default component.exports